export const iconFontAwesomeScienceBiohazard = (
	<i className="fa-solid fa-biohazard"></i>
);
